import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.stock');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-stock',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.stock/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageStockComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public sectionTitle: string = '재고관리';
    public routerSub: any;

    public categories: any = {
        'status': {
            label: '재고현황',
            items: ['현재고현황', '수불현황', '재고항목별월조회']
        },
        'adjust': {
            label: '실사/조정/폐기',
            items: ['실사관리', '조정관리', '폐기관리', '실사/조정/폐기 조회']
        },
        'set': {
            label: '세트재고조정',
            items: ['세트재고조정']
        }
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.updateRoute();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.updateRoute();
                await this.service.render();
            }
        });
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'status';
        try { this.sub = seg.sub ? decodeURIComponent(seg.sub) : ''; } catch { this.sub = seg.sub || ''; }
        if (!seg.category) {
            this.service.href('/stock/status');
        }
    }

    public categoryKeys(): string[] {
        return Object.keys(this.categories);
    }

    public selectSub(item: string) {
        this.sub = item;
        this.service.render();
    }

    public isActiveCat(key: string): boolean {
        return this.category === key;
    }
}

export default PageStockComponent;